// extracted by mini-css-extract-plugin
export default {"root":"OSZqFO6w0vs_z5xzGWtU","error":"rYLLKaCkdfotckReTGkw","placeHolderShimmer":"XyaODyJW4s_tlx5lc_ET"};